<template>
    <div class="flex flex-col justify-between bg-gradient-to-br from-gray-950 via-gray-900/95 to-black min-h-screen">
    <app-header />

    <!-- Main Content -->
    <main class="flex-1 w-full max-w-5xl mx-auto px-4 py-10">
      
      <div class="mt-10 flex flex-col md:flex-row gap-8">
        <!-- Sidebar -->
        <div class="md:w-64 w-full">
          <app-sidebar @filter="onFilterChange" />
        </div>
        <div class="w-full flex flex-col gap-10">
          <universal-search />
          <router-view></router-view>
        </div>
      </div>
    </main>

    <app-footer />
  </div>
</template>


<script setup>
  import AppHeader from '../components/app/AppHeader.vue'
  import AppSidebar from '../components/app/AppSidebar.vue'
  import AppFooter from '../components/app/AppFooter.vue'
  import UniversalSearch from '../components/search/UniversalSearch.vue'
  const onFilterChange = (filters) => {
    console.log(filters)
  }
</script>